import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/mixins/Icon.ts
function Icon(baseClass) {
  class IconMixin extends baseClass {
    connectedCallback() {
      super.connectedCallback();
      this._setLabels();
    }
    updated(changedProperties) {
      super.updated(changedProperties);
      if (changedProperties.has("ariaLabels")) {
        this._setLabels();
      }
    }
    _setLabels() {
      const hasLabel = typeof this.ariaLabels?.label === "string" && this.ariaLabels?.label.length > 0;
      if (hasLabel) {
        this.setAttribute("role", "img");
        this.setAttribute("aria-label", this.ariaLabels.label);
        this.removeAttribute("aria-hidden");
      } else {
        this.removeAttribute("role");
        this.removeAttribute("aria-label");
        this.setAttribute("aria-hidden", "true");
      }
    }
  }
  __decorateClass([
    n({ type: Object })
  ], IconMixin.prototype, "ariaLabels", 2);
  return IconMixin;
}

export {
  Icon
};
